.divider {
  background: var(--comp-divider-color);
  border: none;
  height: 1px;
  margin:  0;
  transition: background-color .3s ease-in-out;
  width: 100%;
}
